import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navigationLinks } from '../data/mock';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Handle navigation - use Link for internal routes, anchor for hash links
  const renderNavLink = (link, isMobile = false) => {
    const isInternalRoute = link.href.startsWith('/') && !link.href.includes('#');
    const baseClasses = isMobile
      ? "block py-3 text-[#A6AFBD] text-base font-medium hover:text-[#F2F4F7] transition-colors"
      : "text-[#A6AFBD] text-sm font-medium hover:text-[#F2F4F7] transition-colors duration-300";

    if (isInternalRoute) {
      return (
        <Link
          to={link.href}
          onClick={() => isMobile && setIsMobileMenuOpen(false)}
          className={baseClasses}
        >
          {link.label}
        </Link>
      );
    }

    return (
      <a
        href={link.href}
        onClick={() => isMobile && setIsMobileMenuOpen(false)}
        className={baseClasses}
      >
        {link.label}
      </a>
    );
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-[#0B0D10]/95 backdrop-blur-md border-b border-white/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <nav className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="text-[#F2F4F7] text-xl font-semibold tracking-tight hover:text-white transition-colors">
            Ramon Govea.<br className="md:hidden" /> Branded AI-Powered Content
          </Link>

          {/* Desktop Navigation */}
          <ul className="hidden md:flex items-center gap-8">
            {navigationLinks.map((link) => (
              <li key={link.label}>
                {renderNavLink(link)}
              </li>
            ))}
          </ul>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-[#F2F4F7] p-2 hover:bg-white/5 rounded transition-colors"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </nav>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden absolute top-20 left-0 right-0 bg-[#0B0D10]/98 backdrop-blur-lg border-b border-white/10">
            <ul className="flex flex-col py-4 px-6">
              {navigationLinks.map((link) => (
                <li key={link.label}>
                  {renderNavLink(link, true)}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
